import React, { useMemo } from 'react';
import { AlarmClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { getOfferDeadline, spotsTakenPercent } from '../utils/offer';
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}

/** Urgency block placed right above the price card. */
export function CountdownTimer() {
  const deadline = useMemo(() => getOfferDeadline(), []);
  const {
    days,
    hours,
    minutes,
    seconds,
    isExpired
  } = useCountdown(deadline);
  const totalHours = days * 24 + hours;
  const units = [{
    value: totalHours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  return <div className="rounded-3xl border border-danger/40 bg-danger/10 px-5 py-7 text-center sm:px-8" data-id="element-31" data-mp="15exwpjnelxdp">
      <p className="flex items-center justify-center gap-2 font-display text-base font-bold uppercase tracking-[0.16em] text-danger" data-id="element-32" data-mp="34pgwsuf2s0ld">
        <AlarmClockIcon className="h-5 w-5" strokeWidth={2} aria-hidden="true" data-id="element-33" data-mp="2zpkuczm10h7x" />
        Launch price — ends in:
      </p>

      {isExpired ? <p className="mt-4 font-display text-2xl font-bold uppercase text-fg" data-id="element-34" data-mp="1h0b3espkz60l">
          The launch price has ended.
        </p> : <>
          <div className="mx-auto mt-5 grid max-w-md grid-cols-3 gap-2.5 sm:gap-3" aria-hidden="true" data-id="element-35" data-mp="12423rq1s2qnn">
            {units.map(unit => <div key={unit.label} className="flex flex-col items-center justify-center rounded-2xl border border-line bg-ink px-2 py-4 text-center" data-id="element-36" data-mp="173ojc652wizm">
                <span className="block font-display text-5xl font-extrabold leading-none tabular-nums text-fg" data-id="element-37" data-mp="1zp7w4s5bxqgp">
                  {pad(unit.value)}
                </span>
                <span className="mt-2 block font-display text-xs font-semibold uppercase tracking-[0.16em] text-muted" data-id="element-38" data-mp="1q06gx46lzd3s">
                  {unit.label}
                </span>
              </div>)}
          </div>
          <p className="sr-only" role="timer" data-id="element-39" data-mp="2ihagoel3dqw8">
            {totalHours} hours, {minutes} minutes and {seconds} seconds left
            until the launch price ends.
          </p>

          <div className="mt-6 border-t border-line pt-5" data-id="element-40" data-mp="2ndmw0pbfycx0">
            <div className="flex items-baseline justify-between gap-4 font-display text-sm font-semibold uppercase tracking-[0.14em] text-muted" data-id="element-41" data-mp="2ne64lff7boyd">
              <span data-id="element-42" data-mp="2ed895litwpre">Launch spots</span>
              <span className="text-danger" data-id="element-43" data-mp="2ec6kufcsy6rq">Only a few left</span>
            </div>
            <div className="mt-3 h-2.5 w-full overflow-hidden rounded-full bg-ink" role="progressbar" aria-valuenow={spotsTakenPercent} aria-valuemin={0} aria-valuemax={100} aria-label="Launch spots already taken" data-id="element-44" data-mp="29e51rufdm7g9">
              <div className="h-full rounded-full bg-danger" style={{
            width: `${spotsTakenPercent}%`
          }} data-id="element-45" data-mp="1zova2fog2qso" />
            </div>
            <p className="mt-2 text-right text-sm text-muted" data-id="element-46" data-mp="1vknmiltq3gw1">
              {spotsTakenPercent}% of spots taken
            </p>
          </div>
        </>}
    </div>;
}